import api from "./client";

// 인증 관련 API
export const authAPI = {
  // 로그인
  login: async (userId, password) => {
    try {
      const response = await api.post("/api/v1/auth/login", {
        userId,
        password,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // 로그아웃
  logout: async () => {
    try {
      const response = await api.post("/api/v1/auth/logout");
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // 토큰 갱신
  refreshToken: async () => {
    try {
      const refreshToken = sessionStorage.getItem("refreshToken");
      const response = await axios.post(`/api/v1/auth/refresh`, null, {
        params: { refreshToken: refreshToken },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // 현재 사용자 정보 조회
  getUserInfo: async ({ config = {} }) => {
    try {
      const response = await api.get("/api/v1/auth/me", config);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // 비밀번호 변경
  getSessionContext: async ({ config = {} } = {}) => {
    const response = await api.get("/api/v1/auth/session-context", config);
    return response.data;
  },

  changePassword: async (currentPassword, newPassword) => {
    try {
      const response = await api.post("/api/v1/auth/change-password", {
        currentPassword,
        newPassword,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // 비밀번호 재설정 요청
  requestPasswordReset: async (email) => {
    try {
      const response = await api.post("/api/v1/auth/password-reset/request", {
        email,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // 비밀번호 재설정 확인
  resetPassword: async (token, newPassword) => {
    try {
      const response = await api.post("/api/v1/auth/password-reset/confirm", {
        token,
        newPassword,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // 토큰 유효성 검증
  validateToken: async () => {
    try {
      const response = await api.get("/api/v1/auth/validate");
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // 세션 연장
  extendSession: async () => {
    try {
      const response = await api.post("/api/v1/auth/extend-session");
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // 모든 세션 종료 (다른 기기에서의 로그인 해제)
  logoutAllSessions: async () => {
    try {
      const response = await api.post("/api/v1/auth/logout-all");
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default authAPI;
